import { UeElement } from '@oneaudi/falcon-tools';
import React, { useContext } from 'react';
import { ContextServiceTracking } from '../FeatureApp';
import { Picture } from './Picture';
import { MaybeLink } from './MaybeLink';
import { StyledBanner } from './style';

type BannerProps = {
  alignment: string;
  ctaUrl?: string;
  imageAlt: string;
  imageSrcLarge: string;
  imageSrcMedium?: string;
  imageSrcSmall?: string;
  fullWidth: boolean;
};

export const Banner = ({
  alignment,
  ctaUrl,
  imageAlt,
  imageSrcLarge,
  imageSrcMedium,
  imageSrcSmall,
  fullWidth,
}: BannerProps) => {
  const [mediaSize, setMediaSize] = React.useState('Small');
  const serviceTracking = useContext(ContextServiceTracking);

  const ueElementImageProperty = `assetImage${mediaSize}`;

  const onClick = () => {
    if (serviceTracking) {
      const sanitizedUrl = serviceTracking.sanitizeUrl(ctaUrl || '');
      const eventAction = serviceTracking.evaluateLinkType(sanitizedUrl || '');
      const targetURL =
        sanitizedUrl.startsWith('#') && typeof window !== 'undefined'
          ? `${window.location.href.split('#')[0]}${sanitizedUrl}`
          : sanitizedUrl;
      const event = {
        eventInfo: {
          eventAction,
          eventName: 'pencil banner - click on banner ',
        },
        attributes: {
          componentName: 'pencil-banner',
          label: imageAlt,
          targetURL,
          clickID: '',
          elementName: 'banner link',
          value: '',
          pos: '',
          relatedElements: [],
        },
      };
      serviceTracking?.track({ event });
    }
  };

  React.useEffect(() => {
    const updateSize = () => {
      if (window.innerWidth < 375) {
        setMediaSize('Small');
      } else if (window.innerWidth < 768) {
        setMediaSize('Medium');
      } else {
        setMediaSize('Large');
      }
    };

    updateSize();

    window.addEventListener('resize', updateSize);
    return () => {
      window.removeEventListener('resize', updateSize);
    };
  }, [mediaSize]);

  return (
    <StyledBanner
      data-testid="Banner"
      alignment={alignment}
      onClick={onClick}
      fullWidth={fullWidth}
    >
      <UeElement type="media" property={ueElementImageProperty} label={`Image ${mediaSize}`}>
        {(ueImageProps) => (
          <MaybeLink ctaUrl={ctaUrl} {...ueImageProps} fullWidth={fullWidth}>
            <Picture
              imageAlt={imageAlt}
              imageSrcLarge={imageSrcLarge}
              imageSrcMedium={imageSrcMedium}
              imageSrcSmall={imageSrcSmall}
              fullWidth={fullWidth}
              {...ueImageProps}
            />
          </MaybeLink>
        )}
      </UeElement>
    </StyledBanner>
  );
};
export default Banner;
